/* eslint-disable @typescript-eslint/no-empty-function */

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { IPerson, PersonUtility } from "src/app/interfaces";
import { IStageMark } from "src/app/interfaces/stageMark";
import { environment } from "src/environments/environment";

@Component({
    selector: "circ-chrome",
    templateUrl: "./chrome.component.html",
    styleUrls: ["./chrome.component.scss"],
    standalone: false
})
export class ChromeComponent implements OnInit, OnChanges {
  @Input() public person: IPerson;
  @Input() public stageMark: IStageMark;
  @Input() public disabled: boolean;

  @Output() public aboutClick = new EventEmitter<IPerson>();
  @Output() public toggleLanguageClick = new EventEmitter();
  @Output() public logoutClick = new EventEmitter();
  @Output() public iconClick = new EventEmitter();
  @Output() public throw = new EventEmitter<ErrorEvent>();

  public logoBtnUrl: string = environment.assets.logo;
  public imageSrc: string;
  public initials: string;
  public data: Array<unknown> = [
    {
      displayName: "chrome_dropdown_aboutMe",
      click: (): void => {
        this.aboutClick.emit(this.person);
      }
    },
    {
      displayName: "chrome_dropdown_toggleLanguage",
      click: (): void => {
        this.toggleLanguageClick.emit();
      }
    },
    {
      displayName: "chrome_dropdown_logout",
      click: (): void => {
        this.logoutClick.emit();
      }
    }
  ];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (typeof changes["person"] === "undefined") {
      return;
    }

    this.setPersonImage();
  }

  public ngOnInit(): void {
    if (typeof this.disabled === "undefined") {
      this.disabled = false;
    }
    if (!this.person) {
      this.throw.emit(
        new ErrorEvent("NullReferenceException ", {
          error: new Error("Person is not set"),
          message: "Person is not set",
          filename: "chrome.component"
        })
      );
      return;
    }

    this.setPersonImage();
  }

  public setPersonImage(): void {
    this.imageSrc = null;
    this.initials = null;
    if (this.person.imageSrc) {
      // do *not* supply both image and initals.
      this.imageSrc = this.person.imageSrc;
    } else {
      this.initials = PersonUtility.initials(this.person);
    }
  }

  public onIconClick(): void {
    this.iconClick.emit();
  }
}
